import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CalculationResult } from '../../models/calculationModels';
import { ControlData } from '../../models/control-data';
import { DiagramDataModel } from '../../models/diagram-data-model';
import { DiagramInfo } from '../../models/diagram-info';
import { DiagramModel } from '../../models';
import { CalculationType } from '../../enums/calculation-type.enum';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-diagrams',
    templateUrl: './diagrams.component.html',
    styleUrls: ['./diagrams.component.scss'],
})
export class DiagramsComponent {
    @Input() diagramInfo: DiagramDataModel;
    @Input() isRedirect: boolean;
    @Input() calcOutput: CalculationResult;
    @Input() calculationType: CalculationType;
    @Output() CalcOverrides: EventEmitter<ControlData> = new EventEmitter();
    @Output() diagram: EventEmitter<DiagramInfo> = new EventEmitter();
    @Output() DiagramFormData: EventEmitter<any> = new EventEmitter();

    ringNumber: string;
    diagramResponse: DiagramModel;

    diagramControlDataHandler(controlData: ControlData) {
        this.CalcOverrides.emit(controlData);
    }

    diagramDataHandler(diagramInfo: DiagramInfo) {
        this.diagram.emit(diagramInfo);
    }

    ringNumberDataHandler(ringNumber: string) {
        this.ringNumber = ringNumber;
    }

    diagramDataResponseHandler(event: DiagramModel) {
        this.diagramResponse = event;
    }

    DiagramFormDataHandler($event) {
        this.DiagramFormData.emit($event);
    }
}
